var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navigation-bar"},[_c('navigation-menu-for-pc'),_c('navigation-menu-for-mobile')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }